"use strict";
// Set defaults
window.Swal = Swal.mixin({
    width: 430,
    heightAuto: false,
    padding: '1.8rem',
    buttonsStyling: false,
    customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-secondary'
    },
    confirmButtonColor: null,
    cancelButtonColor: null
});